module.exports = __webpack_public_path__ + "img/_link.ea4ca76c.svg";